export default __webpack_public_path__ + "static/media/GAME.f84ecd48.gif";